<template>
  <b-badge pill class="animated fadeIn" :variant="variant">
    <span v-if="!loading">{{ value || "N/A" }}</span>
    <i v-else class="fa fa-spin fa-spinner"></i>
  </b-badge>
</template>

<script>
import LabIndicatorModel from "@/models/lab/IndicatorModel";
import CashierIndicatorModel from "@/models/cashier/IndicatorModel";
import CrmIndicatorModel from "@/models/crm/IndicatorModel";

export default {
  name: "IndicatorBadge",
  props: {
    indicator_filter: {
      type: Object,
      default: () => null,
    },
    indicator_key: {
      type: String,
      default: null,
    },
    indicator_service: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      indicator: null,
      value: null,
      loading: true,
    };
  },
  methods: {
    fetch() {
      this.loading = true;
      let indicator = null;
      switch (this.indicator_service) {
        case "cashier":
          indicator = new CashierIndicatorModel();
          break;
        case "crm":
          indicator = new CrmIndicatorModel();
          break;
        case "lab":
        default:
          indicator = new LabIndicatorModel();
      }
      indicator.latest(this.indicator_key, this.indicator_filter).then(() => {
        this.indicator = indicator;
        this.value = indicator.value;
        this.loading = false;
      });
    },
  },
  watch: {
    indicator_filter: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.fetch();
        }
      },
      immediate: true,
    },
  },
};
</script>
